/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';
import { CreateSurveyRequest } from '../../models/create-survey-request';

export interface CreateSurvey$Plain$Params {
  
    /**
     * properties of survey to create
     */
    body?: CreateSurveyRequest
}

export function createSurvey$Plain(http: HttpClient, rootUrl: string, params?: CreateSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
  const rb = new RequestBuilder(rootUrl, createSurvey$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyModel>;
    })
  );
}

createSurvey$Plain.PATH = '/api/Survey';
